import React from 'react'
import { TablaMisOficinas } from '../../Components/Components'

export const MisOficinas = ({initState,updateState,data,load,reload}) => {
  return (
    <React.Fragment>
      <TablaMisOficinas initState={initState} updateState={updateState} data={data} load={load} reload={reload} />
    </React.Fragment>
  )
}